import PropTypes from 'prop-types';
import React from 'react';

import RichTextWithGlossary from '$partials/glossary/rich-text-with-glossary.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleNarrowStepsBlock = ({ items = [] }) => {
    return (
        <section className='layout-container relative my-40 md:mb-80 last:mb-40'>
            <div className='layout-grid-negative-gutter md:flex'>
                <div className='md:w-1/12 layout-grid-col-padding' />

                <div className='md:w-11/12 sm:flex items-baseline'>
                    <div className='layout-grid-col-padding sm:w-4/12 md:w-4/11' />

                    <div className='layout-grid-col-padding sm:w-8/12 md:w-6/11'>
                        <div className='mb-30 md:mb-40'>
                            {items?.map((item, idx) => {
                                return (
                                    <React.Fragment key={idx}>
                                        <div className='md:flex items-baseline border-t border-black md:border-none mt-40 md:mt-0'>
                                            <p className={`type-style-4 mb-15 md:mb-20 md:mr-20 mt-30${idx === 0 ? ' md:mt-0' : ''}`}>
                                                {`Step ${idx+1}`}
                                            </p>

                                            <p className='type-style-3 mb-15 md:mb-0'>
                                                {item.heading}
                                            </p>
                                        </div>

                                        {item.body && (
                                            <RichTextWithGlossary
                                                className='rich-text type-style-4'
                                                html={item.body} />
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    items: PropTypes.array
};

ModuleNarrowStepsBlock.propTypes = propTypes;

export default ModuleNarrowStepsBlock;
